import { Link, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const navigate = useNavigate();

  const footerCategories = categories.slice(0, 6);

  return (
    <footer className="relative bg-foreground-900 text-white">
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-4">
              Ready to discover?
            </h3>
            <p className="font-body text-sm text-foreground-300 leading-relaxed mb-6">
              Start exploring organized SuperBuy spreadsheets and find products faster today.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="btn-primary bg-white text-foreground-900 hover:bg-background-100 inline-flex items-center text-sm"
            >
              SuperBuy Sheet
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Categories
            </h4>
            <ul className="space-y-2.5">
              {footerCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Resources
            </h4>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => navigate('/guide/superbuy-spreadsheet-guide')}
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  Complete Guide
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/guide/superbuy-spreadsheet-beginners')}
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  Beginner&apos;s Handbook
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/guide/superbuy-spreadsheet-sneakers')}
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  Sneaker Guide
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/guide/superbuy-spreadsheet-safety')}
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  Safety Guide
                </button>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer"
                >
                  Main Website
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-label text-sm font-semibold text-white mb-4 uppercase tracking-wider">
              Stay Connected
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="ri-global-line"></i>
                  Main Website
                </a>
              </li>
              <li>
                <Link
                  to="/guide/superbuy-spreadsheet-guide"
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="ri-article-line"></i>
                  Shopping Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="font-body text-sm text-foreground-300 hover:text-white transition-colors duration-200 cursor-pointer inline-flex items-center gap-2"
                >
                  <i className="ri-shopping-bag-line"></i>
                  Shop Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link
            to="/"
            className="font-heading text-lg font-bold text-white tracking-tight"
          >
            SuperBuy <span className="font-sans font-light text-foreground-400">Spread</span>
          </Link>
          <p className="font-body text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} SuperBuy Spread. Independent shopping research platform.
            All external links open with <strong>noopener noreferrer</strong> for your safety.
          </p>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 pointer-events-none select-none overflow-hidden">
        <p className="font-heading text-[12vw] md:text-[8vw] font-black text-foreground-800/10 leading-none whitespace-nowrap text-center">
          SUPERBUY SPREAD
        </p>
      </div>
    </footer>
  );
}